import React from 'react';
import './DispositionGapBadge.css';

const LABELS = {
  critical: 'Critical',
  partial:  'Partial',
  complete: 'Complete',
};

export default function DispositionGapBadge({ level }) {
  if (!level) return null;
  const label = LABELS[level] || level;
  return (
    <span className={`dispositions-gap-badge dispositions-gap-${level}`}>
      {label}
    </span>
  );
}
